const {
	begin, finish, config, slack,
	primary, accent, danger, error,
	inquirer, newline, warn
} = require('../common.js')
const fs = require('fs')
const path = require('path')
const _ = require('lodash')
const chalk = require('chalk')
const stripAnsi = require('strip-ansi')
const Q = require('q')

// const script = require('../libraries/qa_script')
const script = {}

const name = config.get('name')
const slackReport = {}

module.exports = yargs => {

	begin('qa')
		.then(_loadScripts)
		.then(_selectScriptSections)

}

function _loadScripts() {
	return new Promise((resolve, reject) => {
		console.log("\tloading script files...\n")
	
		const qaDirPath = path.join(config.get('ops_client_path'), '/qa')
	
		fs.readdirSync(qaDirPath).forEach(file => {
			const filePath = path.join(qaDirPath, file)
			const displayName = file
				.split(".")
				.slice(0, -1)
				.join(".")
				.replace("-", " ")
	
			try {
				script[displayName] = JSON.parse(fs.readFileSync(filePath, 'utf8'))
			} catch (err) {
				warn(`JSON parse error in ${file}, skipping`)
			}
		})

		resolve()
	})
}

function _selectScriptSections() {

	inquirer.prompt([{
		type: 'checkbox',
		message: 'qa sections to run:',
		name: 'sections',
		choices: Object.keys(script)
	}]).then(({ sections }) => {
		if (!sections.length) return
		_startQa(sections)
	})

}

function _startQa(sections=[]) {

	newline()

	let sectionsMsg = ''

	if (sections.length === 1) 
	{
		sectionsMsg = '*' + sections[0] + '*'
	} 
	else if (sections.length === 2) 
	{
		sectionsMsg = '*' + sections[0] + '*' +
			' and ' + '*' + sections[1] + '*'
	} 
	else 
	{
		sectionsMsg = sections
			.slice(0, sections.length - 1)
			.map(section => '*' + section + '*')
			.join(', ') + ', and ' + '*' + sections[sections.length - 1] + '*'
	}

	slack.message(
		`*${name.first}* ` +
		'started QA for ' +
		sectionsMsg
	)

	sections
		.map(section => (acc, next) => _runQaSection(section, script[section]))
		.reduce(Q.when, Q())
		.then(_finishQa)
		.catch(err => console.log(err))

}

function _runQaSection(name, groups) {

	console.log(chalk.cyan(`\t${name} --\n`))
	slackReport[name] = []

	return groups
		.map(group => (acc, next) => _runQaGroup(group, slackReport[name]))
		.reduce(Q.when, Q())

}

function _runQaGroup({ group, tests }, slackReport) {

	console.log(`\t${group}`)
	slackReport.push({
		group,
		tests: [],
		failed: []
	})

	return tests
		.map(test => (acc, next) =>
			_runQaTest(test, slackReport[slackReport.length - 1]))
		.reduce(Q.when, Q())
		.then(() => {
			newline()
			// slackReport.push(`\n`)
			return
		})

}

function _runQaTest(test, report) {

	return inquirer.prompt([{
		type: 'list',
		name: 'result',
		message: chalk.gray(test),
		choices: [
			accent('pass'),
			danger('fail'),
			chalk.gray('skip'),
			// 'defer' // TO DO
		]
	}]).then(({ result }) => {

		result = stripAnsi(result)

		if (result === 'pass') report.tests.push(`✓ ${test}`)
		if (result === 'fail') report.tests.push(`\`✗ ${test}\``)
		if (result === 'skip') report.tests.push(`_(skip) ${test}_`)

		if (result !== 'fail') return

		return inquirer.prompt([{
			type: 'input',
			name: 'note',
			message: chalk.gray('note:'),
			filter: text => danger(text)
		}]).then(({ note }) => {
			report.failed.push({ test, note: stripAnsi(note) })
			return
		})

	})

}

function _generateSlackAttachments(report) {

	const reports = []
	const failed = []

	for (let key in report) 
	{
		const section = report[key]

		const failedCount = section
			.reduce((acc, group) => acc + group.failed.length, 0)
		const text = failedCount ?
			failedCount === 1 ?
				`Failed 1 test.` : `Failed ${failedCount} tests.`
			: 'Passed all tests.'

		const color = failedCount ? undefined : '#5fc7e1'

		reports.push({
			mrkdwn_in: ["text", "fields"],
			color,
			text,
			title: _.startCase(key),
			// footer: 'ops v' TO DO
			ts: Date.now() / 1000,
			fields: section.map(group => ({
				title: _.startCase(group.name),
				value: group.tests.join('\n'),
				short: false
			}))
		})

		section.forEach(group => {
			group.failed.forEach(({ test, note }) => {
				failed.push({
					title: `✗ ${test}`,
					mrkdwn_in: ["text"],
					color: 'danger',
					text: note,
					footer: `${_.startCase(key)}: ${_.startCase(group.name)}`
				})
			})
		})
	}

	return { reports, failed }

}

function _finishQa() {

	console.log('\tsending report\n')

	const { reports, failed } = _generateSlackAttachments(slackReport)

	slack
		.richMessage({ attachments: reports })
		.then(() => Q.all(failed.map(fail => {
			slack.richMessage({
				attachments: [fail]
			})}
		)))
		.then(() => {
			console.log(accent('\tdone'))
			finish()
		})
		.catch(err => {
			console.log(err)
			error('qa', 'could not send report to slack')
			finish()
		})

}



// WEBPACK FOOTER //
// ./src/commands/qa.js